import styled from "styled-components";
import Input from "../../../../../../components/input/input";
import { colours } from "../../../../../../styles/colours.constants";
import {
	satoshi500,
	satoshi700,
} from "../../../../../../styles/font.constants";

export const CreatePoll = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
`;

export const Row = styled.div`
	width: 100%;
	margin-bottom: 1.5rem;
`;

export const PollLabel = styled.div`
	${satoshi700}
	font-size: 1rem;
	margin-bottom: 0.5rem;
`;

export const PollInput = styled(Input)`
	margin-bottom: 0.5rem;
`;

export const AddOptionButton = styled.button`
	width: 100%;
	border-radius: 0.5rem;
	outline: none;
	appearance: none;
	border-style: dashed;
	border-width: 2px;
	border-color: ${colours.greyDark};
	padding: 0.6rem;
	color: ${colours.black}D9;
	font-size: 1.1rem;
	background: ${colours.white};
	${satoshi500}
	letter-spacing: 4%;
	cursor: pointer;

	&:hover {
		background: ${colours.greyLight};
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	width: 100%;
	gap: 1rem;
`;

export const OptionRow = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	gap: 0.6rem;

	button {
		margin-top: -6px;
	}
`;
